// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CT2-","rootNoMargin":"styles_rootNoMargin__3ezz6"};